import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

/* Layout */
import Layout from "../views/layout/Layout";

/**
 * hidden: true                   if `hidden:true` will not show in the sidebar(default is false)
 * alwaysShow: true               if set true, will always show the root menu, whatever its child routes length
 *                                if not set alwaysShow, only more than one route under the children
 *                                it will becomes nested mode, otherwise not show the root menu
 * redirect: noredirect           if `redirect:noredirect` will no redirct in the breadcrumb
 * name:'router-name'             the name is used by <keep-alive> (must set!!!)
 * meta : {
    title: 'title'               the name show in submenu and breadcrumb (recommend set)
    icon: 'svg-name'             the icon show in the sidebar,
  }
 **/
export const constantRouterMap = [
  {
    path: "/login",
    component: () => import("@/views/login/index"),
    hidden: true
  },
  { path: "/404", component: () => import("@/views/404"), hidden: true },
  {
    path: "",
    component: Layout,
    redirect: "/home",
    children: [
      {
        path: "home",
        name: "home",
        component: () => import("@/views/home/index"),
        meta: { title: "首页", icon: "home" }
      }
    ]
  }
];

export const asyncRouterMap = [
  {
    path: "/pms",
    component: Layout,
    redirect: "/pms/product",
    name: "pms",
    meta: { title: "商品", icon: "product" },
    children: [
      {
        path: "product",
        name: "product",
        component: () => import("@/views/pms/product/index"),
        meta: { title: "商品列表", icon: "product-list" }
      },
      {
        path: "addProduct",
        name: "addProduct",
        component: () => import("@/views/pms/product/add"),
        meta: { title: "添加商品", icon: "product-add" }
      },
      {
        path: "updateProduct",
        name: "updateProduct",
        component: () => import("@/views/pms/product/update"),
        meta: { title: "修改商品", icon: "product-add" },
        hidden: true
      },
      {
        path: "productCate",
        name: "productCate",
        component: () => import("@/views/pms/productCate/index"),
        meta: { title: "商品分类", icon: "product-cate" }
      },
      {
        path: "addProductCate",
        name: "addProductCate",
        component: () => import("@/views/pms/productCate/add"),
        meta: { title: "添加商品分类" },
        hidden: true
      },
      {
        path: "updateProductCate",
        name: "updateProductCate",
        component: () => import("@/views/pms/productCate/update"),
        meta: { title: "修改商品分类" },
        hidden: true
      },
      {
        path: "productAttr",
        name: "productAttr",
        component: () => import("@/views/pms/productAttr/index"),
        meta: { title: "商品类型", icon: "product-attr" }
      },
      {
        path: "productAttrList",
        name: "productAttrList",
        component: () => import("@/views/pms/productAttr/productAttrList"),
        meta: { title: "商品属性列表" },
        hidden: true
      },
      {
        path: "addProductAttr",
        name: "addProductAttr",
        component: () => import("@/views/pms/productAttr/addProductAttr"),
        meta: { title: "添加商品属性" },
        hidden: true
      },
      {
        path: "updateProductAttr",
        name: "updateProductAttr",
        component: () => import("@/views/pms/productAttr/updateProductAttr"),
        meta: { title: "修改商品属性" },
        hidden: true
      }
    ]
  },
  {
    path: "/oms",
    component: Layout,
    redirect: "/oms/order",
    name: "oms",
    meta: { title: "订单", icon: "order" },
    children: [
      {
        path: "order",
        name: "order",
        component: () => import("@/views/oms/order/index"),
        meta: { title: "订单列表", icon: "product-list" }
      },
      {
        path: "orderDetail",
        name: "orderDetail",
        component: () => import("@/views/oms/order/orderDetail"),
        meta: { title: "订单详情" },
        hidden: true
      },
      {
        path: "deliverOrderList",
        name: "deliverOrderList",
        component: () => import("@/views/oms/order/deliverOrderList"),
        meta: { title: "发货列表" },
        hidden: true
      },
      {
        path: "orderSetting",
        name: "orderSetting",
        component: () => import("@/views/oms/order/setting"),
        meta: { title: "订单设置", icon: "order-setting" }
      },
      {
        path: "returnApply",
        name: "returnApply",
        component: () => import("@/views/oms/apply/index"),
        meta: { title: "退货申请处理", icon: "order-return" }
      },
      {
        path: "returnReason",
        name: "returnReason",
        component: () => import("@/views/oms/apply/reason"),
        meta: { title: "退货原因设置", icon: "order-return-reason" }
      },
      {
        path: "returnApplyDetail",
        name: "returnApplyDetail",
        component: () => import("@/views/oms/apply/applyDetail"),
        meta: { title: "退货原因详情" },
        hidden: true
      },
      {
        path: "logisticsList",
        name: "logisticsList",
        component: () => import("@/views/oms/order/logisticsList/index"),
        meta: { title: "物流公司", icon: "product-list" }
      }
    ]
  },
  {
    path: "/umsm",
    component: Layout,
    redirect: "/umsm/member",
    name: "umsm",
    meta: { title: "用户", icon: "user" },
    children: [
      {
        path: "member",
        name: "member",
        component: () => import("@/views/umsm/member/index"),
        meta: { title: "用户列表", icon: "product-list" }
      },
      {
        path: "feedback",
        name: "feedback",
        component: () => import("@/views/umsm/feedback/index"),
        meta: { title: "用户反馈", icon: "product-list" }
      }
    ]
  },
  {
    path: "/punch",
    component: Layout,
    redirect: "/punch/log",
    name: "punch",
    meta: { title: "打卡", icon: "user" },
    children: [
      {
        path: "punch",
        name: "punch",
        component: () => import("@/views/punch/log/index"),
        meta: { title: "打卡", icon: "product-list" }
      }
    ]
  },
  {
    path: "/tms",
    component: Layout,
    redirect: "/tms/team",
    name: "tms",
    meta: { title: "团队", icon: "order" },
    children: [
      {
        path: "team",
        name: "team",
        component: () => import("@/views/tms/team/index"),
        meta: { title: "团队列表", icon: "product-list" }
      },
      {
        path: "teamaudit",
        name: "teamaudit",
        component: () => import("@/views/tms/teamaudit/index"),
        meta: { title: "团队审核", icon: "product-list" }
      },
      {
        path: "activity",
        name: "activity",
        component: () => import("@/views/tms/activity/index"),
        meta: { title: "资讯列表", icon: "product-list" }
      },
      {
        path: "activityaudit",
        name: "activityaudit",
        component: () => import("@/views/tms/activityaudit/index"),
        meta: { title: "资讯审核", icon: "product-list" }
      }
    ]
  },
  {
    path: "/sms",
    component: Layout,
    redirect: "/sms/site",
    name: "sms",
    meta: { title: "餐厅", icon: "sms" },
    children: [
      {
        path: "site",
        name: "site",
        component: () => import("@/views/sms/site/index"),
        meta: { title: "餐厅列表", icon: "sms-flash" }
      },
      {
        path: "siteaudit",
        name: "siteaudit",
        component: () => import("@/views/sms/siteaudit/index"),
        meta: { title: "餐厅审核", icon: "sms-flash" }
      }
      // {
      //   path: 'activity',
      //   name: 'activity',
      //   component: () => import('@/views/sms/activity/index'),
      //   meta: {title: '活动列表', icon: 'sms-flash'}
      // },
      // {
      //   path: 'activityaudit',
      //   name: 'activityaudit',
      //   component: () => import('@/views/sms/activityaudit/index'),
      //   meta: {title: '活动审核', icon: 'sms-flash'}
      // }
    ]
  },
  {
    path: "/bms",
    component: Layout,
    redirect: "/bms/banner",
    name: "bms",
    meta: { title: "banner", icon: "order" },
    children: [
      {
        path: "banner",
        name: "banner",
        component: () => import("@/views/bms/banner/index"),
        meta: { title: "轮播", icon: "product-list" }
      }
    ]
  },
  {
    path: "/sys",
    component: Layout,
    redirect: "/sys/system",
    name: "sys",
    meta: {
      title: "系统消息",
      icon: "sms-ad"
    },
    children: [
      {
        path: "system",
        name: "system",
        component: () => import("@/views/sys/system/index"),
        meta: {
          title: "系统消息",
          icon: "sms-new"
        }
      }
    ]
  },
  {
    path: "/ams",
    component: Layout,
    redirect: "/ams/medal",
    name: "medal",
    meta: { title: "勋章", icon: "order" },
    children: [
      {
        path: "medalclass",
        name: "medalclass",
        component: () => import("@/views/ams/medalclass/index"),
        meta: { title: "勋章分类", icon: "product-list" }
      },
      {
        path: "medal",
        name: "medal",
        component: () => import("@/views/ams/medal/index"),
        meta: { title: "勋章管理", icon: "product-list" }
      }
    ]
  },
  {
    path: "/ams",
    component: Layout,
    redirect: "/ams/shareImg",
    name: "share",
    meta: { title: "分享", icon: "order" },
    children: [
      {
        path: "shareImg",
        name: "shareImg",
        component: () => import("@/views/ams/shareImg/index"),
        meta: { title: "分享图管理", icon: "product-list" }
      },
      {
        path: "shareText",
        name: "shareText",
        component: () => import("@/views/ams/shareText/index"),
        meta: { title: "分享文案管理", icon: "product-list" }
      }
    ]
  },
  {
    path: "/ams",
    component: Layout,
    redirect: "/ams/config",
    name: "ams",
    meta: { title: "配置", icon: "sms" },
    children: [
      {
        path: "config",
        name: "config",
        component: () => import("@/views/ams/config/index"),
        meta: { title: "全局配置", icon: "sms-flash" }
      },
      // {
      //   path: 'problem',
      //   name: 'problem',
      //   component: () => import('@/views/ams/problem/index'),
      //   meta: {title: '常见问题', icon: 'sms-flash'}
      // },
      {
        path: "joinPath",
        name: "joinPath",
        component: () => import("@/views/ams/joinPath/index"),
        meta: { title: "共创吃素吧", icon: "sms-flash" }
      }
    ]
  },
  {
    path: "/ums",
    component: Layout,
    redirect: "/ums/admin",
    name: "ums",
    meta: { title: "系统", icon: "ums" },
    children: [
      {
        path: "admin",
        name: "admin",
        component: () => import("@/views/ums/admin/index"),
        meta: { title: "用户列表", icon: "ums-admin" }
      },
      {
        path: "role",
        name: "role",
        component: () => import("@/views/ums/role/index"),
        meta: { title: "角色列表", icon: "ums-role" }
      },
      {
        path: "allocMenu",
        name: "allocMenu",
        component: () => import("@/views/ums/role/allocMenu"),
        meta: { title: "分配菜单" },
        hidden: true
      },
      {
        path: "allocResource",
        name: "allocResource",
        component: () => import("@/views/ums/role/allocResource"),
        meta: { title: "分配资源" },
        hidden: true
      },
      {
        path: "menu",
        name: "menu",
        component: () => import("@/views/ums/menu/index"),
        meta: { title: "菜单列表", icon: "ums-menu" }
      },
      {
        path: "addMenu",
        name: "addMenu",
        component: () => import("@/views/ums/menu/add"),
        meta: { title: "添加菜单" },
        hidden: true
      },
      {
        path: "updateMenu",
        name: "updateMenu",
        component: () => import("@/views/ums/menu/update"),
        meta: { title: "修改菜单" },
        hidden: true
      },
      {
        path: "resource",
        name: "resource",
        component: () => import("@/views/ums/resource/index"),
        meta: { title: "资源列表", icon: "ums-resource" }
      },
      {
        path: "resourceCategory",
        name: "resourceCategory",
        component: () => import("@/views/ums/resource/categoryList"),
        meta: { title: "资源分类" },
        hidden: true
      }
    ]
  },
  { path: "*", redirect: "/404", hidden: true }
];

export default new Router({
  // mode: 'history', //后端支持可开
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRouterMap
});



// WEBPACK FOOTER //
// ./src/router/index.js